import {
  createContext,
  useCallback,
  useEffect,
  useMemo,
  useState,
} from 'react';
import {
  ChildrenType,
  WishListContextType,
  WishListResponse,
} from '../interface/interface';
import { useAuth } from 'react-oidc-context';
import { getWishListForPatient } from '../service/getWishListForPatient';

const WishListContext = createContext({} as WishListContextType);

const WishListContextProvider = ({ children }: ChildrenType) => {
  const { user } = useAuth();
  const [wishListDetail, setWishListDetail] = useState<
    Array<WishListResponse> | undefined
  >();
  const [wishLoading, setWishLoading] = useState<boolean>(false);

  const callWishList = useCallback(async () => {
    try {
      setWishLoading(true);
      const token = user?.access_token;

      if (!token) {
        return false;
      }

      const wishListDetail = await getWishListForPatient(token);

      const responseData = wishListDetail;
      setWishListDetail(responseData);
    } catch (error) {
      console.error('Failed to fetch wishList details');
      throw error;
    } finally {
      setWishLoading(false);
    }
  }, [user?.access_token]);

  useEffect(() => {
    callWishList();
  }, [callWishList]);

  const value = useMemo(
    () => ({
      wishListData: wishListDetail,
      setWishListData: setWishListDetail,
      callWishList: callWishList,
      wishLoading: wishLoading,
    }),
    [wishListDetail, callWishList, wishLoading],
  );

  return (
    <WishListContext.Provider value={value}>
      {children}
    </WishListContext.Provider>
  );
};

export { WishListContext, WishListContextProvider };
